export default __webpack_public_path__ + "static/17-e9c13fee9da1d2f642e7a0c6d6233990.png";